import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// Redux
import { PagosOnline } from "./app/pages/pagosOnline/PagosOnline";
import { ResultadoPago } from "./app/pages/pagosOnline/ResultadoPago";
import { DescargarComprobantePago } from "./app/pages/pagosOnline/DescargarComprobantePago";
import "./app/sass/style.scss";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<PagosOnline />} />
      <Route path="/pagoRapido/:idpago" element={<PagosOnline />} />
      <Route path="/pagoFinalizado" element={<ResultadoPago />} />

      <Route
        path="/comprobantePago/:ref_payco/:id_cliente"
        element={<DescargarComprobantePago />}
      />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);
